import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Toggle, Row } from '../settingsPrimitives';
import { useCertificateStore } from '../../store/certificateStore';

/**
 * The warning shown whenever SSL certificate verification is off. One
 * component, so Settings → Requests and Settings → Certificates cannot say
 * different things about the same switch.
 */
export const SslVerificationOffWarning = ({ t }) => (
  <div className="settings-ssl-off-warning" role="alert">
    <AlertTriangle size={14} className="settings-ssl-off-warning-icon" aria-hidden="true" />
    <span>{t('settings.sslVerificationOffWarning')}</span>
  </div>
);

/**
 * THE SSL verification switch (certificateStore `verifySSL`), used on both
 * Settings → Requests and Settings → Certificates: same wording, same
 * polarity (on = verify), same warning. Before 24.09.2026 Certificates had
 * "Disable SSL Verification globally" (on = NOT verifying) and Requests had
 * "SSL certificate verification" (on = verifying) — the same fact, opposite
 * switches.
 *
 * It applies to the user's own requests only; Apiboo's own traffic is always
 * verified (request_preferences::enforce_ssl_policy), and the description
 * says so.
 */
const SslVerificationSetting = ({ t, disabled = false, desc }) => {
  const verifySSL = useCertificateStore((s) => s.verifySSL);
  const setVerifySSL = useCertificateStore((s) => s.setVerifySSL);
  return (
    <>
      <Row label={t('settings.sslVerification')} desc={desc ?? t('settings.sslVerificationDesc')}>
        <Toggle value={verifySSL} onChange={(v) => setVerifySSL(v)} disabled={disabled} />
      </Row>
      {!verifySSL && <SslVerificationOffWarning t={t} />}
    </>
  );
};

export default SslVerificationSetting;
